import { Tooltip } from '@octopus-do/octopus-storybook'
import { OctopusMonoLogo } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useState } from 'react'

import css from './styles.module.css'

interface Props {
  favicon: string | null
}

export const ProjectFavicon: React.FC<Props> = ({ favicon }) => {
  // The favicon lives on someone else's server: it can 404 or refuse us long
  // after the crawl saw it, and a broken image icon looks worse than no logo.
  // What is remembered is the address that failed rather than the failure, so a
  // re-crawl that finds a working icon shows it instead of staying broken.
  const [failedSrc, setFailedSrc] = useState<string | null>(null)

  const shown = favicon === failedSrc ? null : favicon

  return (
    <div className={css.project_favicon}>
      {shown && (
        <img
          src={shown}
          alt=""
          className={css.favicon}
          onError={() => setFailedSrc(shown)}
        />
      )}

      {!shown && (
        <Tooltip label="No favicon found">
          <OctopusMonoLogo className={css.favicon_icon} />
        </Tooltip>
      )}
    </div>
  )
}
